export const mockData = {
  dependentDropdowns: [
    {
      name: 'Product Segment/Brand',
      options: [
        'Acritas',
        'Audit',
        'Carswell',
        'CaseLines',
        'Checkpoint',
        'CLEAR',
        'Cleardocs',
        'Cloud Audit',
        'CoCounsel',
        'Content',
        'CS Professional Suite',
        'Digita',
        'Document Intelligence',
        'DT Professional Suite',
        'Elite',
        'Financial Insights',
        'FindLaw',
        'HighQ',
        'HR Solutions',
        'Institute',
        'Learning and CPE',
        'Legal',
        'MyPay Solutions',
        'ONESOURCE',
        'ONESOURCE - Europe',
        'Onvio',
        'Pondera',
        'Practical Law',
        'Practice Ready',
        'Print',
        'Reuters',
        'Risk',
        'Software Assistant',
        'Specialty Products',
        'Thomson Reuters',
        'Ventures',
        'Westlaw',
        'ZENNOVATE',
      ],
      dependencies: [],
    },
    {
      name: 'Product Title',
      options: {
        Acritas: [
          'Acritas',
          'Advisory',
          'Custom',
          'Sharplegal',
          'Stellar Performance',
        ],
        Audit: [
          'Guided Assurance',
          'Checkpoint Tools',
          'SMART Practice Aids',
          'TR Audit Intelligence',
        ],
        Carswell: ['EYB Online', 'TaxNetPro', 'TaxPartner'],
        CaseLines: ['CaseLines'],
        Checkpoint: [
          'ANZ',
          'Checkpoint',
          'Checkpoint AU',
          'Checkpoint Edge',
          'Checkpoint Marketing',
          'Checkpoint NZ',
          'Checkpoint Research',
          'e-Forms RS',
          'MFA',
          'PACKS',
          'Toolkits',
          'XYZ Financial Accounts',
        ],
        CLEAR: ['CLEAR', 'CLEAR BATCH', 'CLEAR CORE', 'Investigative', 'Tools'],
        Cleardocs: ['Cleardocs One Time', 'Cleardocs Print', 'Cleardocs Sub'],
        'Cloud Audit': ['Checkpoint Manager', 'GoFileRoom'],
        CoCounsel: ['-none-'],
        Content: ['Boskage Print', 'Editorial', 'Quickfinder / Print'],
        'CS Professional Suite': [
          'Accounting CS',
          'FileCabinet CS',
          'Fixed Assets',
          'GoSystem Tax RS',
          'Onvio Firm Mgmt + Add On',
          'Planner CS',
          'Practice CS',
          'Practice Forward',
          'SurePrep',
          'UltraTax CS',
          'Virtual Office CS/SaaS',
          'Workpapers',
        ],
        Digita: [
          'Accounts Production',
          'Accounts Production Advanced',
          'Company Secretarial',
          'Corporation Tax',
          'Corporation Tax Advanced',
          'Data Mining',
          'Digita',
          'IT',
          'Personal Tax',
          'Practice Management',
          'Practice Management Advanced',
          'Virtual Office',
        ],
        'Document Intelligence': [
          'Academy',
          'Automate',
          'Dashboards',
          'Data Utility',
          'Document Insights Legacy',
          'Document Intelligence app',
          'Provision Insights Legacy',
          'Web Extension',
        ],
        'DT Professional Suite': ['DT Professional Suite'],
        Elite: [
          '3E',
          '3E Cloud',
          'Business Dev',
          'Business Systems',
          'eBillingHub',
          'Enterprise',
          'Envision',
          'Mattersphere',
          'ProLaw',
          'ProLaw Ready',
        ],
        'Financial Insights': ['-none-'],
        FindLaw: [
          'FindLaw',
          'Firm Solutions',
          'FL Consumer',
          'FL Returns Reserve',
          'Form - Living Will',
          'Form - Package',
          'Form - Power of Attorney',
          'Form - Will',
          'Lead Solutions',
          'Online Advertising',
          'Super Lawyers',
        ],
        HighQ: [
          'Appliance/Connectors',
          'Collaborate',
          'Dataroom',
          'Integration',
          'Legal Anywhere',
          'Legal Tracker',
          'Non-Product Specific',
          'Publisher',
        ],
        'HR Solutions': ['BigRedSky', 'CVMail', 'IworkforSA', 'RAMS'],
        Institute: ['Institute'],
        'Learning and CPE': ['Checkpoint Learning', 'Gear Up', 'TR Learning'],
        Legal: [
          'Business Law Center',
          'Carswell Online',
          'Case Notebook',
          'CoCounsel',
          'Contract Express',
          'Customer Success Portal',
          'Data Privacy Advisor',
          'Deadline Assistant',
          'Document Intelligence',
          'Drafting Assistant',
          'eFiling',
          'Firm Central',
          'Form Builder',
          'HighQ',
          'JCT',
          'La Reference',
          'Legal Home',
          'Legal Tracker Advanced',
          'Monitor Suite',
          'MyAccount',
          'Other',
          'Patron Access Seat',
          'PL Canada',
          'Practical Law Connect',
          'Practical Law UK',
          'Practical Law US',
          'Print Products',
          'ProDoc',
          'Proview',
          'QuickView',
          'Real Legal',
          'Specialty Products (generic for all remaining)',
          'TWEN',
          'West KM',
          'Westlaw',
          'Westlaw Books',
          'Westlaw Today',
          'Westlaw UK',
        ],
        'MyPay Solutions': ['MyPay Solutions'],
        ONESOURCE: [
          'Administration',
          'Akore',
          'Alteryx',
          'API Administration',
          'BEPS Action Manager',
          'Calendar',
          'CFDI',
          'Corporate Tax',
          'DAC6',
          'DataFlow',
          'DataHub',
          'Direct Tax',
          'Direct Tax API',
          'Direct Tax Dashboards',
          'E-Invoicing',
          'Estimated Payments',
          'Express RS',
          'Fast Sales Tax',
          'FileRoom',
          'Fringe Benefits Tax',
          'General Ledger Manager',
          'General Ledger Manager Classic',
          'Global Access',
          'Global Tax Audit Manager',
          'Global Trade Management',
          'Global Trade Management - LatAm',
          'GoSystem Tax RS',
          'Income Tax',
          'Income Tax International',
          'Indirect APIs',
          'Indirect Dashboards',
          'Indirect Tax Calculator',
          'Indirect Tax Compliance',
          'Indirect Tax Determination',
          'Indirect Tax Rates',
          'ITC',
          'K1A',
          'Non-Resident Alien Tax',
          'ONESOURCE',
          'Operational Transfer Pricing',
          'Pagero',
          'Platform',
          'Property Tax',
          'Sales & Use Tax Compliance',
          'State Apportionment',
          'Statutory Reporting',
          'Tax Information Reporting',
          'Tax Provision',
          'Tax Provision - Classic',
          'Transfer Pricing Documenter',
          'Trust & Estate Administration',
          'Trust Tax',
          'Trusts (AU)',
          'Uncertain Tax Positions',
          'Workflow',
          'Workflow Manager Classic',
        ],
        'ONESOURCE - Europe': [
          'Alteryx',
          'Calendar',
          'Corporate Tax',
          'DataFlow',
          'DataHub',
          'Determination',
          'GMT',
          'GTM',
          'Indirect Tax',
          'OSR',
          'Tax Compliance',
          'Tax Provision',
          'Tax Provision - Classic',
        ],
        Onvio: [
          'Accounts',
          'Firm Management',
          'Formations',
          'OnBalance',
          'Onvio',
          'Onvio Advisory',
          'Onvio Client Center',
          'Onvio Client Centre & Documents',
          'Onvio Documents',
          'Onvio Firm Management',
          'Onvio Project Manager',
          'Onvio Tax',
          'Onvio Tax ANZ',
          'Onvio Time and Billing',
          'Onvio Workpapers',
          'Personal Tax',
          'Secretarial',
          'VAT',
        ],
        Pondera: ['CaseTracker', 'DataResolver', 'FraudCaster'],
        'Practical Law': [
          'Antitrust',
          'Bankruptcy',
          'Capital Markets',
          'Commercial Transactions',
          'Corp/M&A',
          'Data Privacy Advisor',
          'Employee Benefits',
          'Finance',
          'Government',
          'Intellectual Prop',
          'Labor/Employment',
          'Litigation',
          'PL Australia',
          'Practical Law',
          'Practical Law CA',
          'Practical Law Connect',
          'Practical Law UK',
          'Real Estate',
          'Trust & Estates',
        ],
        'Practice Ready': ['Practice Ready'],
        Print: [
          'Academic',
          'Academy',
          'Carswell',
          'Express Wills',
          'Global Print',
          'Import',
          'JCT',
          'Legal',
          'Proview',
          'Quickfinder / Print',
          'Tax',
          'Trade',
          'UKI Print',
        ],
        Reuters: ['Reuters'],
        Risk: [
          'AEM Risk Admin',
          'ODEN',
          'Regulatory Intelligence',
          'RI API',
          'RI Feeds',
        ],
        'Software Assistant': [
          'ASIC Assistant',
          'Ledger Assistant',
          'Practice Assistant',
          'Tax Assistant',
        ],
        'Specialty Products': [
          'Antitrust',
          'Case Notebook',
          'Connect4',
          'Contract Express',
          'C-Track',
          'CVMail',
          'eDiscovery point',
          'eFiling',
          'Legal Search Connect',
          'Online Dispute Resolution',
          'Other',
          'ProDoc',
          'Real Legal',
          'Safeguard',
        ],
        'Thomson Reuters': [
          'Customer Success Platform',
          'eFiling',
          'Legal Home',
          'Legal Support Center',
          'Market Place',
          'MyAccount',
          'OnePass',
          'QuickView',
          'Service & Support',
        ],
        Ventures: ['Ventures'],
        Westlaw: [
          'Books on Westlaw UK',
          'Business Law Center',
          'Deadline Assistant',
          'Drafting Assistant',
          'Edge',
          'Firm Central',
          'Form Builder',
          'International Materials on Westlaw',
          'LawnB',
          'Lawtel',
          'Legal Core',
          'Legal One',
          'Legal Software',
          'Legal Taxonomy',
          'Monitor Suite',
          'Patron Access Seat',
          'TWEN',
          'West KM',
          'Westlaw ANZ',
          'Westlaw Asia',
          'Westlaw AU',
          'Westlaw Canada',
          'Westlaw China',
          'Westlaw Classic',
          'Westlaw IE',
          'Westlaw Japan',
          'Westlaw Middle East',
          'Westlaw NZ',
          'Westlaw Precision',
          'Westlaw Today',
          'Westlaw UK',
          'WestlawEdge UK',
        ],
        ZENNOVATE: [
          'GCC Tax Invoicing System',
          'GCC VAT Compliance System',
          'GST Compliance',
        ],
      },
      dependencies: ['Product Segment/Brand'],
    },
    {
      name: 'Inquiry Reason',
      options: {
        'Global Trade Management - LatAm': ['None'],
        'Global Trade Management': ['None'],
      },
      dependencies: ['Product Title'],
    },
    {
      name: 'Product Feature Module',
      options: {
        '3E': [
          'AFS/Xcelerate',
          'Data Insights',
          'Platform/Biztalk/Utilities',
          'Practice Mgt, Conflicts, Records',
          'Tech Sys & Server/SecureLink',
          'Templates/Paperless Proforma',
          'Upgrades',
          'WorkSpace / Time Capture',
        ],

        '3E Cloud': [
          'AFS/Xcelerate',
          'Data Insights',
          'Platform/Biztalk/Utilities',
          'Practice Mgt, Conflicts, Records',
          'Tech Sys & Server/SecureLink',
          'Templates/Paperless Proforma',
          'Upgrades',
          'WorkSpace / Time Capture',
        ],

        Academic: ['-none-'],
        Academy: ['-none-'],
        Accounts: ['-none-'],
        'Accounts Production': [
          'Foreign Trade Zone Management - Petro',
          'FRS',
          'IMMEX Management',
          'IT',
          'License',
        ],

        'Accounts Production Advanced': [
          'Data',
          'Filing Error',
          'Foreign Trade Zone Management - Petro',
          'FRS',
          'IMMEX Management',
          'IT',
          'iXBRL',
          'License',
        ],

        Acritas: ['-none-'],
        Administration: [
          'API',
          'Company Info',
          'General functionality',
          'Integration',
          'Notifications',
          'Reference Data',
          'Reports',
          'Setup',
          'User Admin & Access',
        ],

        'Checkpoint Manager': ['-none-'],
        Advisory: ['-none-'],
        'AEM Risk Admin': ['-none-'],
        Akore: ['Akore'],
        Alteryx: ['-none-'],
        Antitrust: ['-none-'],
        ANZ: ['-none-'],
        'API Administration': ['Administration', 'General functionality'],

        'ASIC Assistant': ['Lodgement', 'Registration', 'Validation'],

        Automate: ['-none-'],
        'BEPS Action Manager': [
          'Administration',
          'ATO Validations',
          'Australia Local File',
          'BEPS Monitor',
          'CbC Compliance',
          'CbC Forms',
          'Error message',
          'Master File',
          'Reports',
          'Workpaper',
        ],

        BigRedSky: ['Agency', 'Job Seeker'],

        'Books on Westlaw UK': ['-none-'],
        'Boskage Print': ['-none-'],
        'Business Dev': ['-none-'],
        'Business Law Center': ['-none-'],
        'Business Systems': ['-none-'],
        Calendar: [
          'API',
          'Content',
          'Documents',
          'Due Dates/Scheduling',
          'General functionality',
          'Import',
          'Integration',
          'Notifications',
          'Permissions',
          'Setup',
        ],

        'Capital Markets': ['-none-'],
        Carswell: ['-none-'],
        'Carswell Online': ['-none-'],
        'Case Notebook': ['-none-'],
        CaseTracker: ['-none-'],
        Checkpoint: ['-none-'],
        'Checkpoint AU': [
          'OnePass',
          'Outage',
          'Single Sign On',
          'Usage Reports',
          'User Maintenance',
        ],
        'Checkpoint Edge': ['-none-'],
        'Guided Assurance': ['-none-'],
        'Checkpoint Learning': ['-none-'],
        'Checkpoint Marketing': ['-none-'],
        'Checkpoint NZ': [
          'OnePass',
          'Outage',
          'Single Sign On',
          'Usage Reports',
          'User Maintenance',
        ],
        'Checkpoint Research': [],
        'Checkpoint Tools': [],
        'CLEAR BATCH': [],
        'CLEAR CORE': [],
        'Cleardocs One Time': [],
        'Cleardocs Print': [],
        'Cleardocs Sub': [],
        Collaborate: [
          'Activity',
          'Administration',
          'AI Hub',
          'Blog',
          'Data Visualization',
          'Drive',
          'Email',
          'Files',
          'Home',
          'Hub',
          'iSheets',
          'Login Trouble/Password Reset',
          'My Site',
          'Non-support request',
          'Office Plugin',
          'People Module/Directory',
          'Permissions',
          'Q&A',
          'Reports',
          'Viewer',
          'Wiki',
          'Workflow',
        ],

        'Collaborate Appliance/Connectors': [
          'Administration',
          'Email',
          'Files',
          'iSheets',
          'Login Trouble/Password Reset',
          'Non-support request',
          'Permissions',
          'Reports',
        ],

        'Collaborate Integration': [
          'Administration',
          'Document Automation',
          'Email',
          'Files',
          'License',
          'Login Trouble/Password Reset',
          'Non-support request',
          'Permissions',
          'Reports',
        ],
        'Collaborate Publisher': [
          'Administration',
          'API',
          'ASP Admin',
          'Email',
          'Files',
          'Global Searching',
          'Hub',
          'Keycloak/Unification',
          'Login Trouble/Password Reset',
          'Non-support request',
          'Permissions',
          'Reports',
        ],
        'Commercial Transactions': [],

        'Company Secretarial': [
          'Filing Error',
          'Foreign Trade Zone Management - Petro',
          'IMMEX Management',
          'Integration',
          'IT',
          'License',
          'Reports',
        ],
        Connect4: ['User Maintenance'],
        'Contract Express': [],
        'Corp/M&A': [],

        'Corporate Tax': [
          'Abacus Enterprise Server',
          'Chart of Accounts',
          'Client Mapping',
          'Computations / Calculations',
          'Configuration',
          'Corporate Tax',
          'Electronic Filing',
          'Enhancements',
          'Entities',
          'Error message',
          'Export',
          'Forms',
          'Import',
          'License',
          'Login Trouble/Password Reset',
          'Print',
          'Reports',
          'Rollback / Rollover',
          'Setup',
          'TEA Workpapers',
          'Trial Balance',
          'User Admin & Access',
          'Version',
        ],

        'Corporation Tax': [
          'Data',
          'Deferred Tax',
          'Electronic Filing',
          'Foreign Trade Zone Management - Petro',
          'IMMEX Management',
          'IT',
          'License',
        ],

        'Corporation Tax Advanced': [
          'Data',
          'Electronic Filing',
          'Foreign Trade Zone Management - Petro',
          'Forms /Returns',
          'IMMEX Management',
          'IT',
          'License',
        ],
        'C-Track': [],
        Custom: [],
        'Customer Success Platform': [],

        CVMail: ['Agency', 'Job Seeker'],
        DAC6: ['Reports'],
        Dashboards: [],
        'Data Mining': [
          'Foreign Trade Zone Management - Petro',
          'IMMEX Management',
          'IT',
          'License',
        ],

        'Data Privacy Advisor': [],
        'Data Utility': [],
        DataFlow: [
          'API',
          'Data Provider',
          'Documents',
          'Excel Add-in',
          'General functionality',
          'Import',
          'Integration',
          'Notifications',
          'Setup',
          'Web DataFlow',
        ],

        DataHub: [
          'API',
          'Configuration',
          'General functionality',
          'Integration',
          'Processing',
          'Upload/Download',
        ],
        DataResolver: [],
        Dataroom: [],

        'Deadline Assistant': ['Delivery', 'OnePass'],
        Determination: [],
        Digita: [],
        'Direct Tax': [],
        'Direct Tax API': [],
        'Direct Tax Dashboards': [],
        'Document Insights Legacy': [],
        'Document Intelligence': [],
        'Document Intelligence app': [],

        'Drafting Assistant': ['Delivery', 'OnePass'],
        'DT Professional Suite': [],
        eBillingHub: [],
        Edge: [],
        'eDiscovery point': [],
        Editorial: [],
        eFiling: [],
        'e-Forms RS': [],
        'E-Invoicing': [
          'Integration - Oracle',
          'Other API  Flat File',
          'SAP Integration',
        ],

        'Employee Benefits': [],
        Enterprise: [
          'AFS/Xcelerate',
          'Document Studio',
          'Practice Mgt, Conflicts, Records',
          'Tech Sys & Server/SecureLink',
          'Upgrades',
          'WebView',
        ],

        Envision: [],
        'Estimated Payments': [
          'Data',
          'Import',
          'Print',
          'Reports',
          'Rollback / Rollover',
          'Setup',
          'User Admin & Access',
        ],

        'Express RS': [
          'Account Admin/Environment',
          'API',
          'Browser',
          'Conversion',
          'Data Import Template',
          'DIF/KAT',
          'Direct K1',
          'Electronic Filing',
          'Excel Add-in',
          'Integration',
          'K-1 Analyzer',
          'Letters and Filing Instructions',
          'Locator Access',
          'Locator Free',
          'Locator Transfer',
          'My Tax Info',
          'Organizer / Tax Forms',
          'Print',
          'Rollback / Rollover',
          'Security/Access Control',
          'Tax Defaults',
          'Trial Balance Bridge',
        ],

        'Express Wills': [],
        'EYB Online': [],

        'Fast Sales Tax': [
          'Cancellations',
          'Content & Pricing',
          'Functionality Report',
          'Password Resets',
          'Payments & Refunds',
          'Product Features(API)',
          'User Updates',
        ],
        'FileCabinet CS': [],
        FileRoom: [],
        Finance: [],

        FindLaw: ['Article', 'Listing'],
        'Firm & Workflow Mgmt': [],

        'Firm Central': ['OnePass', 'Quickview'],
        'Firm Management': [
          'Customer Center',
          'Documents',
          'Login Trouble/Password Reset',
          'Setup',
          'System Issue',
        ],
        'Firm Solutions': [],
        'Fixed Assets': [],
        'FL Consumer': [],
        'FL Returns Reserve': [],
        'Form - Living Will': [],
        'Form - Package': [],
        'Form - Power of Attorney': [],
        'Form - Will': [],

        'Form Builder': ['Delivery', 'OnePass'],

        Formations: ['Data', 'Filing Error', 'System Issue'],
        FraudCaster: [],

        'Fringe Benefits Tax': [
          'Administration',
          'Amendment',
          'Benefits',
          'Computations / Calculations',
          'Data',
          'Data Import Template',
          'Database',
          'DB Provisioning',
          'Electronic Filing',
          'Entities',
          'Error message',
          'Forms /Returns',
          'License',
          'Organization',
          'Print',
          'Reports',
          'Return Filing',
          'Rollback / Rollover',
          'Tax Agent',
        ],

        'GCC Tax Invoicing System': [
          'Enterprise Cloud',
          'Master',
          'On-Premise',
          'Original Cloud',
          'Original Dedicated Cloud',
          'Outputs',
          'Reports',
          'Uploads',
        ],

        'GCC VAT Compliance System': [
          'Enterprise Cloud',
          'On-Premise',
          'Original Cloud',
          'Original Dedicated Cloud',
          'Reports',
          'Return Filing',
          'Setup',
          'Uploads',
        ],
        'Gear Up': [],

        'General Ledger Manager': [
          'API',
          'Data',
          'General functionality',
          'Integration',
          'Outputs',
          'Setup',
          'Upload/Download',
          'Data',
          'General functionality',
          'Integration',
          'Outputs',
          'Setup',
          'Upload/Download',
        ],
        'General Ledger Manager Classic': [
          'API',
          'Data',
          'General functionality',
          'Integration',
          'Outputs',
          'Setup',
          'Upload/Download',
          'Data',
          'General functionality',
          'Integration',
          'Outputs',
          'Setup',
          'Upload/Download',
        ],
        'Global Access': [],
        'Global Print': [],
        'Global Tax Audit Manager': [],

        'Global Trade Management': [
          'Analyzer Suite',
          'CAM',
          'Denied Party Screening',
          'Entry Verification',
          'ERP',
          'EU Customs Regime Management',
          'Export Management',
          'Export Verification',
          'Foreign Trade Zone Management - Discrete',
          'Foreign Trade Zone Management - Petro',
          'Free Trade Agreement Management',
          'Global Classification',
          'Global Trade Content',
          'Global Trade Visibility',
          'Government Connectivity',
          'IMMEX Management',
          'Import Management',
          'Platform Add-Ons',
          'Supply Chain Compliance',
          'TH Free Trade Zones',
          'US Drawback',
          'US Importer Security Filing',
          'US QP/WP',
          'US Reconciliation',
        ],

        'Global Trade Management - LatAm': [
          'Broker',
          'Cambio',
          'ComexData',
          'Content',
          'Data Analytics',
          'DUEXP',
          'EASY CONTROL',
          'Export',
          'Import',
          'Infrastructure',
          'INOUT',
          'Integration - Oracle',
          'Integration - SAP',
          'Masterdata',
          'Single Window – Import',
          'Special Programs - BW',
          'Special Programs - DE',
          'Special Programs - Drawback',
          'Special Programs - EV',
          'Special Programs - RECOF',
          'Special Programs - RegInt',
          'Special Programs - REPETRO',
          'TrackingSys',
          'User login / rights',
        ],

        GMT: [],
        GoFileRoom: [],

        'GoSystem Tax RS': [
          'Account Admin/Environment',
          'Browser',
          'Conversion',
          'Data Import Template',
          'DIF/KAT',
          'Direct K1',
          'Electronic Filing',
          'Excel Add-in',
          'Integration',
          'K-1 Analyzer',
          'Letters and Filing Instructions',
          'Locator Access',
          'Locator Free',
          'Locator Transfer',
          'My Tax Info',
          'Organizer / Tax Forms',
          'Print',
          'Rollback / Rollover',
          'Security/Access Control',
          'Tax Defaults',
          'Trial Balance Bridge',
          'Workpaper',
        ],
        Government: [],
        'GST Compliance': [
          'Enterprise Cloud',
          'Master',
          'Master File',
          'On-Premise',
          'Original Cloud',
          'Original Dedicated Cloud',
          'Outputs',
          'Transactions',
          'Uploads',
        ],
        GTM: [],
        'GTM - Gen 4': [],
        'GTM - IP': [],
        Hosted: [],
        Import: [],

        'Income Tax': [
          'API',
          'Balances',
          'Browser',
          'Chart of Accounts',
          'Chart of Adjustments',
          'Conversion',
          'Data Import Template',
          'Dataflow',
          'DIF/KAT',
          'Direct K1',
          'Electronic Filing',
          'Excel Add-in',
          'Help and Support',
          'Integration',
          'K-1 Analyzer',
          'Letters and Filing Instructions',
          'Locator Access',
          'Locator Transfer',
          'Organizer / Tax Forms',
          'Print',
          'Rollback / Rollover',
          'Security/Access Control',
          'Single Sign On',
          'State A&A Workpapers',
          'Tax Accounting',
          'Working Trial Balance',
          'Workpaper',
        ],

        'Income Tax International': [
          'CFC Screens',
          'Charts',
          'Computations / Calculations',
          'Compute/Consolidate',
          'E&P',
          'Electronic Filing',
          'Excel Add-in',
          'FTC Screens',
          'Lookthrough',
          'Organizer / Tax Forms',
          'Print',
          'Rollback / Rollover',
          'Setup',
          'Sourcing Workpapers',
          'Subpart F',
          'System Issue',
          'TAS Screens',
          'TIBS & FTC',
        ],
        'Indirect APIs': [],
        'Indirect Dashboards': [],
        'Indirect Tax': [],

        'Indirect Tax Calculator': [
          'Computations / Calculations',
          'Organizer / Tax Forms',
          'Reports',
          'Scenarios',
        ],

        'Indirect Tax Compliance': [
          'Administration',
          'Configuration',
          'Import',
          'Permissions',
          'Reports',
          'Supplementary Filings',
          'Transactions',
        ],

        'Indirect Tax Determination': [
          'Data Import Template',
          'Electronic Filing',
          'Enhancements',
          'Enterprise Cloud',
          'Entities',
          'On-Premise',
          'Original Cloud',
          'Rollback / Rollover',
          'Setup',
        ],

        'Indirect Tax Rates': ['Login Trouble/Password Reset', 'Tax Rates'],
        Institute: [],
        'Intellectual Prop': [],
        Investigative: [],
        IT: [],
        ITC: [],

        IworkforSA: ['Agency', 'Job Seeker'],
        JCT: [],
        K1A: [],
        'La Reference': [],
        'Labor/Employment': [],
        LawnB: [],
        Lawtel: [],
        'Lead Solutions': [],

        'Ledger Assistant': [
          'Asset Manager',
          'Bank Feeds',
          'General functionality',
          'Investment Manager',
          'Reports',
        ],

        Legal: [
          'Print (International Subscription)',
          'Print (Magazine)',
          'Print (Standing Order)',
          'Print Book',
          'Print Subscription',
        ],
        'Legal Anywhere': [],
        'Legal Core': [],
        'Legal Home': [],
        'Legal One': [],
        'Legal Search Connect': [],
        'Legal Software': [],
        'Legal Support Center': [],
        'Legal Taxonomy': [],

        'Legal Tracker': [
          'AR-Collections',
          'Tracker PS Support',
          'Tracker Support (CO Issues)',
          'Tracker Support (LF Issues)',
        ],
        'Legal Tracker Advanced': [],
        Litigation: [],
        'Market Place': [],
        Mattersphere: [],
        MFA: [],
        'Monitor Suite': [],

        MyAccount: ['OnePass', 'Registration'],
        'MyPay Solutions': [],

        'Non-Product Specific': [
          'Administration',
          'Files',
          'Login Trouble/Password Reset',
          'Non-Product Specific',
          'Non-support request',
          'Permissions',
          'Reports',
        ],

        'Non-Resident Alien Tax': ['Data Navigator', 'Tax Navigator'],
        ODEN: ['Oden Online', 'Policy Terminator', 'SR&R'],

        OnBalance: ['Data', 'System Issue'],
        OnePass: [],
        ONESOURCE: [],
        'Online Advertising': [],
        'Online Dispute Resolution': [],
        Onvio: [],

        'Onvio Advisory': ['Planner', 'Practice Forward'],
        'Onvio Client Center': ['Setup'],
        'Onvio Client Centre & Documents': [],
        'Onvio Documents': ['Recent Activity', 'Recycle Bin'],
        'Onvio Firm Management': ['Documents', 'Print', 'Setup'],
        'Onvio Project Manager': ['Setup'],

        'Onvio Tax': [
          'Administration',
          'Electronic Filing',
          'Print',
          'Setup',
          'Web Questionnaire',
        ],

        'Onvio Tax ANZ': [],
        'Onvio Time and Billing': ['Print', 'Setup'],
        'Onvio Workpapers': ['Engagement Workpapers'],

        'Operational Transfer Pricing': [
          'Administration',
          'Hierarchies',
          'Import',
          'Instance Copy',
          'Operational Data',
          'Output',
          'Reports',
          'Script Upload',
          'Sequences',
          'Workpaper',
        ],
        OSR: [],

        Other: ['Event'],
        PACKS: [],
        Pagero: ['Pagero'],
        'Patron Access Seat': ['All Seats in Use', 'Setup'],
        'Personal Tax': [
          'Corporate Tax',
          'Data',
          'Equalisation',
          'E-Signing',
          'Filing Error',
          'Foreign Trade Zone Management - Petro',
          'IMMEX Management',
          'Integration',
          'IT',
          'License',
        ],

        'PL Australia': [
          'OnePass',
          'Outage',
          'PPV',
          'Single Sign On',
          'Usage Reports',
          'User Maintenance',
        ],
        'PL Canada': [],
        'Planner CS': [],

        Platform: [
          'General functionality',
          'Login Trouble/Password Reset',
          'Product Help',
          'Security/Access Control',
        ],
        'Practical Law': [],
        'Practical Law CA': [],
        'Practical Law Connect': [],

        'Practical Law UK': ['Delivery', 'OnePass'],
        'Practical Law US': ['Delivery', 'OnePass'],

        'Practice Assistant': ['Calendar', 'Time Entry'],
        'Practice CS': [],

        'Practice Management': [
          'Data',
          'Documents',
          'E-Signing',
          'Foreign Trade Zone Management - Petro',
          'Help and Support',
          'IMMEX Management',
          'IT',
          'License',
          'Onvio Uplift (How To)',
          'Reports',
          'Setup',
        ],

        'Practice Management Advanced': [
          'Foreign Trade Zone Management - Petro',
          'IMMEX Management',
          'IT',
          'License',
          'Reports',
          'Setup',
        ],
        'Practice Ready': [],
        'Print Products': [],

        ProDoc: ['License', 'Version'],
        ProLaw: ['ProLaw'],
        'ProLaw Ready': [],

        'Property Tax': [
          'Address Book',
          'API',
          'Asset Center',
          'Browser',
          'Customer Center',
          'Data',
          'Error message',
          'Export',
          'Forms',
          'New Company',
          'OnePass',
          'OneSource SSO',
          'Permissions',
          'Processes',
          'Reports',
          'Tax Center',
          'Tools',
          'Work Flow Center',
        ],
        Proview: ['Missing Title', 'Offline Access'],
        'Provision Insights Legacy': [],
        'Quickfinder / Print': [],
        QuickView: [],

        RAMS: ['Agency', 'Job Seeker'],
        'Real Estate': [],
        'Real Legal': [],

        'Regulatory Intelligence': [
          '500 Internal Server error',
          'Ability to Annotate',
          'Ability to Bookmark',
          'Advanced searching',
          'ARI daily bulletins not received',
          'Calendar',
          'Compare feature functionality',
          'CSV export functionality',
          'Delayed publication',
          'Documents',
          'E mail functionality',
          'Error message',
          'Export',
          'Export Management',
          'Global Search functionality',
          'Homepage options (Featured Articles)',
          'Insight filtering & searching (News & Analysis)',
          'Library search functionality',
          'License',
          'Login Trouble/Password Reset',
          'Manage key feature',
          'Max Support',
          'Missing publication',
          'My Communities access',
          'My Communities feature',
          'My Updates e mail notifications not received',
          'My updates profile creation',
          'My Updates search functionality',
          'No resource error',
          'No session error',
          'OnePass',
          'Outside of subscription error',
          'PDF export functionality',
          'Permissions',
          'Print functionality',
          'Prism date feature toggle accessibility',
          'Product accessibility issue',
          'Red growl error message',
          'Regulatory event summaries coverage',
          'Research library filtering',
          'Resource not found error',
          'Rulebook content coverage',
          'Rulebook language accessibility',
          'SAP Account and generic user profile set up',
          'TRRI - Desktop',
          'TRRI - Feeds',
          'Unauthorized error',
        ],
        Reuters: [],

        'RI API': [
          '500 Internal Server error',
          'Configuration',
          'Content',
          'CSV export functionality',
          'Delayed publication',
          'Delivery',
          'Developer Portal enquiry',
          'Documents',
          'Error message',
          'Export',
          'Export Management',
          'General functionality',
          'Global Search functionality',
          'Homepage options (Featured Articles)',
          'Library search functionality',
          'License',
          'Login Trouble/Password Reset',
          'Missing Publication',
          'No resource error',
          'OnePass',
          'Outside of subscription error',
          'Permissions',
          'Prism date feature toggle accessibility',
          'Product accessibility issue',
          'Red growl error message',
          'Regulatory event summaries coverage',
          'Reports',
          'Research library filtering',
          'Resource not found error',
          'Rulebook content coverage',
          'Rulebook language accessibility',
          'SAP Account and generic user profile set up',
          'Unauthorized error',
          'User Admin & Access',
        ],

        'RI Feeds': [
          '500 Internal Server error',
          'Configuration',
          'Content',
          'CSV export functionality',
          'Delayed publication',
          'Delivery',
          'Developer Portal enquiry',
          'Documents',
          'Error message',
          'Export',
          'Export Management',
          'Failed Feeds',
          'Failed to save feed',
          'General functionality',
          'Global Search functionality',
          'Homepage options (Featured Articles)',
          'Library search functionality',
          'License',
          'Login Trouble/Password Reset',
          'Missing publication',
          'No Resource error',
          'No session error',
          'OnePass',
          'Outside of subscription error',
          'Permissions',
          'Prism date feature toggle accessibility',
          'Product accessibility issue',
          'Red growl error message',
          'Regulatory event summaries coverage',
          'Reports',
          'Research library filtering',
          'Resource not found error',
          'Rulebook content coverage',
          'Rulebook language accessibility',
          'SAP Account and generic user profile set up',
          'TRRI - Desktop',
          'TRRI - Feeds',
          'Unauthorized error',
          'User Admin & Access',
        ],
        Safeguard: [],

        'Sales & Use Tax Compliance': [
          'API',
          'Balance Import',
          'Compliance',
          'Computations / Calculations',
          'Electronic Filing',
          'Error message',
          'Setup',
          'Tools',
          'Transfers',
        ],
        Secretarial: [],

        'Service & Support': [
          'CSP ACCOUNT EXPERIENCE',
          'MY ACCOUNT',
          'NETWORK',
          'SALESFORCE',
        ],
        Sharplegal: [],
        'SMART Practice Aids': [],

        'Specialty Products (generic for all remaining)': [
          'License',
          'Version',
        ],
        'State Apportionment': [
          'Administration',
          'Computations / Calculations',
          'Configuration',
          'Data',
          'Database',
          'Environment',
          'Export',
          'Home',
          'Import',
          'Integration',
          'Jurisdictions',
          'Login Trouble/Password Reset',
          'Planning',
          'Reports',
          'Rollback / Rollover',
          'Scenarios',
          'Tax Rules',
          'User Admin & Access',
        ],

        'Statutory Reporting': [
          'Account Admin/Environment',
          'Administration',
          'Citrix',
          'Content',
          'Database',
          'Electronic Filing',
          'Entities',
          'Error message',
          'Formatting',
          'Import',
          'Installation/Upgrade',
          'iXBRL',
          'License',
          'Login Trouble/Password Reset',
          'OneSource SSO',
          'Print',
          'Reports',
          'Rollback / Rollover',
          'Smart tables',
          'Summary',
          'System Issue',
          'Templates/Paperless Proforma',
          'Upgrades',
          'User Admin & Access',
        ],
        'Stellar Performance': [],
        'Super Lawyers': [],

        Superannuation: [
          'Computations / Calculations',
          'Electronic Filing',
          'Entities',
          'Forms',
          'OneSource SSO',
          'Setup',
        ],
        SurePrep: [],
        Tax: [],

        'Tax Assistant': [
          'Administration',
          'Billing',
          'Data',
          'Database Server',
          'Error message',
          'Import',
          'Installation/Upgrade',
          'License',
          'Lodgement',
          'Prefill Issues',
          'Print',
          'Print functionality',
          'Tax Estimate/Calculation',
          'Upgrades',
          'Validation',
        ],
        'Tax Compliance': [],

        'Tax Information Reporting': [
          'API',
          'Compliance',
          'Fed Filing',
          'Import',
          'Print',
          'Reports',
          'Review and Maintenance',
          'Secured Environment',
          'Securities Pricing',
          'State Filing',
          'Tax Programs',
          'User Admin & Access',
        ],

        'Tax Provision': [
          'Administration',
          'Citrix',
          'Data',
          'DB Provisioning',
          'Excel Add-in',
          'Export',
          'Global Access',
          'Import',
          'Integration',
          'License',
          'Reports',
          'Review and Maintenance',
          'Upgrades',
        ],
        'Tax Provision - Classic': [
          'Administration',
          'Citrix',
          'Data',
          'DB Provisioning',
          'Excel Add-in',
          'Export',
          'Global Access',
          'Import',
          'Integration',
          'License',
          'Reports',
          'Review and Maintenance',
          'Upgrades',
        ],
        TaxNetPro: [],
        TaxPartner: [],
        Toolkits: [],
        Tools: [],
        'TR Audit Intelligence': [],
        'TR Learning': [],
        Trade: [],

        'Transfer Pricing Documenter': [
          'DealScan',
          'Fileroom',
          'Import',
          'ktMINE',
          'Master File',
          'Reports',
        ],

        'Trust & Estate Administration': [
          'Accounting',
          'Back Up Schedules',
          'Check Writer/Reconciliation',
          'Compliance',
          'Estate Planner (zCalc)',
          'Reports',
          'Securities Pricing',
          'Tax Programs',
        ],
        'Trust & Estates': [],

        'Trust Tax': [
          '1099',
          '5498',
          'API',
          'Computations / Calculations',
          'Data Load / Bridge',
          'Documents',
          'Electronic Filing',
          'Estimates',
          'Factoring',
          'Forms /Returns',
          'General: Error Messages',
          'General: Preparer Notes',
          'Income Tax (1041)',
          'K-1 Analyzer',
          'OTEA Bridge',
          'Print',
          'Registers: Building',
          'TAW',
          'User Admin & Access',
          'Workflow Management',
          'WSC Plus',
        ],

        'Trusts (AU)': [
          'Administration',
          'Chart of Accounts',
          'Computations / Calculations',
          'Configuration',
          'Distributions',
          'Electronic Filing',
          'Entities',
          'Error message',
          'Export',
          'Forms',
          'Import',
          'OneSource SSO',
          'Reports',
          'Setup',
          'Workpaper',
        ],

        TWEN: ['Registration'],
        'UKI Print': [],
        'UltraTax CS': [],

        'Uncertain Tax Positions': [
          'Export',
          'Import',
          'Login Trouble/Password Reset',
          'Reports',
          'User Admin & Access',
        ],

        VAT: ['Data', 'Filing Error', 'System Issue'],
        Ventures: [],

        'Virtual Office': [
          '2 Factor',
          '500 Internal Server error',
          'Citrix',
          'Foreign Trade Zone Management - Petro',
          'IMMEX Management',
          'IT',
          'License',
        ],
        'Virtual Office CS/SaaS': [],
        'Web Extension': [],
        WebBuilder: [],
        'West KM': [],

        Westlaw: ['Delivery', 'OnePass'],
        'Westlaw ANZ': [],

        'Westlaw Asia': [
          'Alerts',
          'OnePass',
          'Outage',
          'PPV',
          'Single Sign On',
          'Usage Reports',
          'User Maintenance',
        ],

        'Westlaw AU': [
          'Alerts',
          'OnePass',
          'Outage',
          'PPV',
          'Single Sign On',
          'Usage Reports',
          'User Maintenance',
        ],

        'Westlaw Canada': ['OnePass', 'Single Sign On'],
        'Westlaw China': ['OnePass', 'Single Sign On'],
        'Westlaw Classic': [
          'Alerts',
          'OnePass',
          'Outage',
          'PPV',
          'Single Sign On',
          'Usage Reports',
          'User Maintenance',
        ],
        'Westlaw IE': [],

        'Westlaw Japan': ['OnePass', 'Single Sign On'],
        'Westlaw Middle East': [],

        'Westlaw NZ': [
          'Alerts',
          'OnePass',
          'Outage',
          'PPV',
          'Single Sign On',
          'Usage Reports',
          'User Maintenance',
        ],

        'Westlaw Precision': [
          'Alerts',
          'OnePass',
          'Outage',
          'PPV',
          'Single Sign On',
          'Trials',
          'Usage Reports',
          'User Maintenance',
        ],
        'Westlaw Today': [],

        'Westlaw UK': ['Delivery', 'OnePass'],
        'WestlawEdge UK': [],

        Workflow: [
          'General functionality',
          'Integration',
          'Notifications',
          'Setup',
          'Tasks',
          'Workflow',
        ],
        'Workflow Manager': [
          'Administration',
          'API',
          'Calendar',
          'Dataflow',
          'Fileroom',
          'Workflow',
          'Workpaper',
        ],

        'Workflow Manager Classic': [
          'API',
          'Calendar',
          'Dataflow',
          'DB Provisioning',
          'Entities',
          'Fileroom',
          'General functionality',
          'Setup',
          'Workflow',
          'Workpaper',
        ],
        Workpapers: [],
        'XYZ Financial Accounts': [],
      },
      dependencies: ['Product Title'],
    },
    {
      name: 'Product Function',
      options: {
        '1099': [],
        '5498': [],
        '500 Internal Server error': [],
        'Abacus Enterprise Server': [],
        'Ability to Bookmark': [],
        'ACA Filing': [],
        'Account Admin/Environment': [],
        Accounting: [],
        Accreditation: [],
        Activity: [],
        'Address Book': [],

        Administration: [
          'API access',
          'API Authentication',
          'Events',
          'Other',
          'Rate Limits',
          'Reports',
        ],

        ADS: [],
        'AFS/Xcelerate': [],
        Agency: [],
        'AI Hub': [],
        Akore: [],
        'All Seats in Use': [],
        'Analyzer Suite': [],
        API: [],
        Article: [],
        'ASP Admin': [],
        'Asset Center': [],
        'Australia Local File': [],
        'Back Up Schedules': [],
        'Balance Import': [],
        Balances: [],
        'BEPS Monitor': [],
        Blog: [],
        Branding: [],

        Broker: ['Sisco'],
        Browser: [],
        Calendar: [],
        CAM: [],

        Cambio: ['Export', 'Import'],
        Cancellations: [],
        'CbC Compliance': [],
        'CbC Forms': [],
        'CFC Screens': [],
        'Chart of Accounts': [],
        'Chart of Adjustments': [],
        Charts: [],
        Citrix: [],
        'CN Processing Trade Regime Management': [],

        'Company Info': [
          'Accounts',
          'Clients',
          'Entities',
          'Location',
          'Other',
        ],
        Compliance: [],
        'Computations / Calculations': [],
        'Compute/Consolidate': [],

        Configuration: ['Blueprints', 'Schematics'],
        Content: [],
        'Content & Pricing': [],
        Conversion: [],
        'Corporate Tax': [],
        'Country of Origin': [],
        Courses: [],

        'CSP ACCOUNT EXPERIENCE': ['OUTAGE'],
        'CSV export functionality': [],
        'Customer Center': [],
        Data: [],
        'Data Analytics': [],
        'Data Import Template': [],
        'Data Insights': [],
        'Data Load / Bridge': [],
        'Data Navigator': [],
        'Data Visualization': [],
        Database: [],
        Dataflow: [],
        DealScan: [],
        'Deferred Balances': [],
        'Delayed publication': [],
        Delivery: [],
        'Denied Party Screening': [],
        'Depreciation Table': [],
        'Developer Portal enquiry': [],
        'DIF/KAT': [],
        'Direct K1': [],
        'Document Automation': [],
        'Document Studio': [],
        Documents: [],
        DPS: [],
        Drive: [],
        'Due Dates/Scheduling': [],
        DUEXP: [],
        'Duty Drawback - US': [],
        'E mail functionality': [],
        'E&P': [],

        'EASY CONTROL': ['Drawback', 'Export', 'Financing', 'Import'],
        'Electronic Filing': [
          'Alerts',
          'Informational Diagnostics',
          'Rejects',
          'Severe Diagnostics',
          'XML Validation Errors',
          'Filing Status',
        ],
        Email: [],
        'Engagement Workpapers': [],
        Enterprise: [],

        'Enterprise Cloud': [
          'Address Validation Service',
          'Big Commerce',
          'Certificate Manager',
          'Content as a Service',
          'Content Extracts',
          'Coupa',
          'Custom or Partner Integration',
          'Data File Integrator',
          'DB Provisioning',
          'E-Invoicing',
          'Integration as a Service (IaaS)',
          'International Tax Content',
          'Microsoft Dynamics 365 - Commerce Cloud',
          'Microsoft Dynamics 365FOE',
          'Microsoft Dynamics AX 2012',
          'Microsoft Dynamics Business Central',
          'Microsoft Dynamics Customer Engagement (CRM)',
          'Microsoft Dynamics GP',
          'NetSuite Legacy/Direct',
          'NetSuite Suite Tax',
          'ONESOURCE Platform',
          'Oracle Commerce',
          'Oracle EBS R12',
          'Oracle ERP Cloud',
          'Oracle ERP Cloud Content',
          'Reports & Analytics - Cloud',
          'Salesforce Commerce B2B',
          'Salesforce Subscription Management',
          'SAP 5.2B Basic (RFC)',
          'SAP Ariba',
          'SAP Business One',
          'SAP C4/HANA Commerce Cloud',
          'SAP Concur',
          'SAP Global Next',
          'SAP Global Tax Service',
          'SAP US Tax S4/HANA Cloud',
          'Tax Calculation Services',
          'US Tax Content',
        ],

        'Entry Verification': [],
        Environment: [],
        Equalisation: [],
        ERP: [],
        'Error message': [],
        'Estate Planner (zCalc)': [],
        Estimates: [],
        'EU Customs Regime Management': [],
        'Excel Add-in': [],
        'Excel Import': [],
        Export: [],
        'Export Management': [],
        'Export SMB': [],
        'Export Verification': [],
        'EZ-FTZ': [],
        Factoring: [],
        'Failed Feeds': [],
        'Failed to save feed': [],
        'Fed Filing': [],
        'Fiduciary Calendar': [],
        Fileroom: [],
        Files: [],
        'Filing Error': [],
        'Filing Error Forms': [],
        "For Nat'l Information System (FNIS)": [],
        "For Nat'l Tax Resources (FNTR)": [],
        'Foreign Trade Zone Management - Discrete': [],
        'Foreign Trade Zone Management - Petro': [],
        Formatting: [],
        'Forms /Returns': [],
        'Free Trade Agreement Management': [],
        FRS: [],
        'FTA Data Repository': [],
        'Functionality Report': [],
        'General functionality enquiry': [],
        'General: Error Messages': [],
        'General: Knowledgebase': [],
        'General: Preparer Notes': [],
        'Global Access': [],
        'Global Classification': [],
        'Global Search functionality': [],
        'Global Searching': [],
        'Global Trade Content': [],
        'Global Trade Visibility': [],
        'Global Visibility': [],

        'Government Connectivity': [
          'DE Export Declaration Filing',
          'DE Import Declaration Filing',
          'NL Export Declaration Filing',
          'NL Import Declaration Filing',
          'NL NCTS Filing',
          'US Export Declaration Filing (AES)',
          'US Import Declaration Filing (ABI-01)',
          'US Import Declaration Filing (ABI-06)',
        ],

        Hierarchies: [],
        Home: [],
        'Homepage options (Featured Articles)': [],
        Hub: [],
        'IMMEX Management': [],
        Import: [],
        'Import Management': [],
        'Import SMB': [],
        'IN Customs Warehouse/Drawback': [],
        'IN Special Economic Zone': [],
        'Income Tax (1041)': [],
        Infrastructure: [],

        INOUT: ['Legacy'],
        'Insight filtering & searching (News & Analysis)': [],
        'Installation/Upgrade': [],
        'Instance Copy': [],

        Integration: [
          'Administration - Company Info',
          'Alteryx',
          'Corporate Tax',
          'Data Hub',
          'DataFlow',
          'Income Tax',
          'Indirect Determination',
          'Other',
          'SAP S4 HANA',
          'Statutory Reporting',
          'Tax Provision',
          'Workpapers',
        ],

        'Integration - Oracle': ['BPEL', 'DBLink', 'Fusion Cloud'],

        'Integration - SAP': ['PI/CPI', 'RFC', 'SOA Manager', 'TXT'],

        iSheets: [],
        IT: [],
        iXBRL: [],
        'Job Seeker': [],
        Jurisdictions: [],
        'K-1 Analyzer': [],
        'Keycloak/Unification': [],
        'Knowledge Network': [],
        Knowledgebase: [],
        ktMINE: [],
        'Landed Cost Management': [],
        'Letters and Filing Instructions': [],
        'Library search functionality': [],
        License: [],
        Listing: [],
        'Locator Access': [],
        'Locator Transfer': [],
        'Lodgment VPN': [],
        'Login Trouble/Password Reset': [],
        Lookthrough: [],
        'Managed Service': [],
        'Managed Users': [],
        Master: [],
        'Master File': [],
        Masterdata: [],
        'Max Support': [],
        'Missing Title': [],

        'MY ACCOUNT': ['DATA/CONTENT ISSUE', 'OUTAGE'],
        'My Communities access': [],
        'My Communities feature': [],
        'MY Licensed Manufacturing Warehouse': [],
        'My Site': [],
        'NAFT Assistant': [],
        NETWORK: ['OUTAGE'],
        'New Company': [],
        'No resource error': [],
        'Non-Product Specific': [],
        'Non-support request': [],
        Notifications: [],
        'Oden Online': ['User profile Set UP'],
        'Office Plugin': [],
        'Offline Access': [],
        'OneSource SSO': [],

        'On-Premise': [
          'Address Validation Service',
          'Big Commerce',
          'Certificate Manager',
          'Content as a Service',
          'Content Extracts',
          'Coupa',
          'Custom or Partner Integration',
          'Data File Integrator',
          'DB Provisioning',
          'E-Invoicing',
          'Integration as a Service (IaaS)',
          'International Tax Content',
          'Microsoft Dynamics 365 - Commerce Cloud',
          'Microsoft Dynamics 365FOE',
          'Microsoft Dynamics AX 2012',
          'Microsoft Dynamics Business Central',
          'Microsoft Dynamics Customer Engagement (CRM)',
          'Microsoft Dynamics GP',
          'NetSuite Legacy/Direct',
          'NetSuite Suite Tax',
          'ONESOURCE Platform',
          'Oracle Commerce',
          'Oracle EBS R12',
          'Oracle ERP Cloud',
          'Oracle ERP Cloud Content',
          'Original Reporting',
          'Salesforce Commerce B2B',
          'Salesforce Subscription Management',
          'SAP 5.2B Basic (RFC)',
          'SAP Ariba',
          'SAP Business One',
          'SAP C4/HANA Commerce Cloud',
          'SAP Concur',
          'SAP Global Next',
          'SAP Global Tax Service',
          'SAP US Tax S4/HANA Cloud',
          'Tax Calculation Services',
          'US Tax Content',
        ],

        'Operational Data': [],
        'Organizer / Tax Forms': [],

        'Original Cloud': [
          'Address Validation Service',
          'Big Commerce',
          'Certificate Manager',
          'Content as a Service',
          'Content Extracts',
          'Coupa',
          'Custom or Partner Integration',
          'Data File Integrator',
          'DB Provisioning',
          'E-Invoicing',
          'Integration as a Service (IaaS)',
          'International Tax Content',
          'Microsoft Dynamics 365 - Commerce Cloud',
          'Microsoft Dynamics 365FOE',
          'Microsoft Dynamics AX 2012',
          'Microsoft Dynamics Business Central',
          'Microsoft Dynamics Customer Engagement (CRM)',
          'Microsoft Dynamics GP',
          'NetSuite Legacy/Direct',
          'NetSuite Suite Tax',
          'ONESOURCE Platform',
          'Oracle Commerce',
          'Oracle EBS R12',
          'Oracle ERP Cloud',
          'Oracle ERP Cloud Content',
          'Original Reporting',
          'Reports & Analytics - Cloud',
          'Salesforce Commerce B2B',
          'Salesforce Subscription Management',
          'SAP 5.2B Basic (RFC)',
          'SAP Ariba',
          'SAP Business One',
          'SAP C4/HANA Commerce Cloud',
          'SAP Concur',
          'SAP Global Next',
          'SAP Global Tax Service',
          'SAP US Tax S4/HANA Cloud',
          'Tax Calculation Services',
          'US Tax Content',
        ],

        'Original Dedicated Cloud': [],
        'OS IDT Determ on Prem': [],
        'OTEA Bridge': [],
        Output: [],
        Outputs: [],
        Pagero: [],
        'Password Resets': [],
        'Payments & Refunds': [],
        'People Module/Directory': [],
        Permissions: [],
        Planner: [],
        Planning: [],
        'Platform Add-Ons': [],
        'Platform/Biztalk/Utilities': [],
        'Policy Terminator': ['Diagnostic Tool'],
        Portal: [],
        'Practice Forward': [],
        'Practice Mgt, Conflicts, Records': [],
        Print: [],
        'Print functionality': [],
        'Prism date feature toggle accessibility': [],
        Processes: [],

        Processing: ['Aggregation Logic', 'Collections', 'Topics'],

        'Product Features(API)': [],
        'Product Help': [],
        ProLaw: [],
        'Q&A': [],
        QPWP: [],
        Quickview: [],
        'Recent Activity': [],
        'Recycle Bin': [],
        'Reference Data': [],
        'Registers: Building': [],
        Reports: [],
        'Research library filtering': [],
        'Resource not found error': [],
        'Return Filing': [],
        'Review and Maintenance': [],
        'Rollback / Rollover': [],
        'Rulebook language accessibility': [],

        SALESFORCE: [
          'ACCESS',
          'BEST PRACTICE IDEA',
          'DATA/CONTENT ISSUE',
          'OUTAGE',
        ],

        'Script Upload': [],
        'Secured Environment': [],
        'Securities Pricing': [],

        'Security/Access Control': [
          'Account lockout',
          'IP Authorization',
          'MultiFactor Authentication',
          'Product Access',
          'Single SignOn',
        ],

        Sequences: [],
        Setup: [],
        'Single Window – Import': [],
        Siscoserv: [],
        'Smart tables': [],
        'Solicitation for Government Procurement': [],
        'Sourcing Workpapers': [],
        'Special Programs - BW': [],
        'Special Programs - DE': [],

        'Special Programs - Drawback': ['Isenção', 'Suspensão'],
        'Special Programs - EV': [],
        'Special Programs - RECOF': ['SPED'],
        'Special Programs - REPETRO': ['Industrialização'],
        'State A&A Workpapers': [],
        'State Filing': [],
        'Subpart F': [],
        Suites: [],
        Summary: [],
        'Supplementary Filings': [],
        'Supply Chain Compliance': [],
        'System Issue': [],
        'Tariff Analyzer': [],
        'TAS Screens': [],
        TAW: [],
        'Tax Accounting': [],
        'Tax Center': [],
        'Tax Navigator': [],
        'Tax Programs': [],
        'Tax Rates': [],
        'Tax Rules': [],
        'Tech Sys & Server/SecureLink': [],
        'Templates/Paperless Proforma': [],
        'TH Free Trade Zones': [],
        'Time Entry': [],
        Tools: [],
        'Totvs Comex': [],

        'Tracker Support (CO Issues)': [
          'Accounting Codes',
          'Accounts Payable',
          'Accruals',
          'AFA',
          'Analytics',
          'API/Web Services – Access',
          'API/Web Services - Informational',
          'API/Web Services - Not Hosted (Customer Programmed)',
          'API/Web Services - TR hosted',
          'Budget',
          'Bulk Update',
          'Company Profile',
          'Dashboard',
          'Documents - Matter Doc Upload',
          'Documents/FileZone/Contracts',
          'Email Notifications',
          'Firms',
          'Help Site/Training Request/Tutorial Q',
          'HighQ',
          'Invoice Approval',
          'Invoice Audits, Rejection & Adjustment, Billing Guidelines',
          'Invoice Posting',
          'Invoice Tax',
          'Legal Hold - Exterro',
          'Legal Hold - Total Discovery',
          'Matter Creation',
          'Matter Management',
          'Matter Participant',
          'Matter Type Templates',
          'Matter Upload',
          'Misc. Request',
          'OnePass',
          'OnePass - Transfer required',
          'Org Units/Practice Groups',
          'Reports',
          'SFTP',
          'Sign In Page',
          'SOP',
          'SSO - Active Directory',
          'SSO - OnePass',
          'SSO - OnePass SAML',
          'Substantive Law',
          'Technical - Browser',
          'Technical - General Slowness',
          'Timekeeper Rate Review',
          'TR Customer Service',
          'UI',
          'User Locked Out',
          'Users',
          'Volume Discounts',
        ],

        'Tracker Support (LF Issues)': [
          'Accruals',
          'Budget',
          'Documents',
          'E-Billing Hub',
          'Email Notifications',
          'Firm Access to Client Database',
          'Firm Merge',
          'Firm Profile',
          'Invoice - LEDES Generator',
          'Invoice - LEDES Troubleshooting',
          'Invoice - Posting/Re-posting',
          'Invoice Behavior',
          'Invoice Tax',
          'LSA',
          'Matter Management / Incomplete Tasks',
          'Matter Participant',
          'Misc. Request',
          'OnePass',
          'OnePass - Transfer required',
          'Reports',
          'Sign In Page',
          'Technical - Browser',
          'TK Rate Sheet',
          'TR Customer Service',
          'Training',
          'UI',
          'User Locked Out',
          'Users',
        ],

        TrackingSys: ['Export', 'Import'],
        Transfers: [],
        'Trial Balance': [],
        'Trial Balance Bridge': [],
        'TRRI - Desktop': [],
        'TRRI - Feeds': [],
        Upgrades: [],
        'Upload/Download': [],
        Uploads: [],
        'US Drawback': [],
        'US Importer Security Filing': [],
        'US QP/WP': [],

        'User Admin & Access': [
          'Groups',
          'Other',
          'Product Permissions',
          'Users',
        ],

        'User login / rights': [],
        'User Updates': [],
        Version: [],
        Viewer: [],
        'WCO Explanatory Notes': [],
        'Web Questionnaire': [],
        WebView: [],
        Wiki: [],
        'Work Flow Center': [],
        Workflow: [],
        'Workflow Management': [],
        'Working Trial Balance': [],
        Workpaper: [],
        'WorkSpace / Time Capture': [],
        'WSC Plus': [],
      },
      dependencies: ['Product Feature Module'],
    },
  ],
  columns: 3,
};
